import NoteList from '@/components/NoteList'
import { isReplyNoteEvent } from '@/lib/event'
import { getDefaultShowKinds } from '@/lib/kind-filter'
import { toProfile } from '@/lib/link'
import { SecondaryPageLink } from '@/PageManager'
import { TFeedSubRequest } from '@/types'
import { useEffect, useMemo, useRef, useState } from 'react'
import { TNoteListRef } from '@/components/NoteList'
import { Event } from '@nostr/tools/wasm'
import { useTranslation } from 'react-i18next'
import { includeRepliesAtom } from '@/atoms/feed'
import { useAtomValue } from 'jotai'

export default function GroupedProfileFeed({ pubkey }: { pubkey: string }) {
  const { t } = useTranslation()
  const includeReplies = useAtomValue(includeRepliesAtom)
  const [subRequests, setSubRequests] = useState<TFeedSubRequest[]>([])
  const noteListRef = useRef<TNoteListRef>(null)
  const showKinds = useMemo(() => getDefaultShowKinds(), [])

  // calculate timeframe boundary from grouped notes settings
  const groupedNotesSince = Math.floor(Date.now() / 1000 - window.hallway.universe.groupedTimeframe)

  useEffect(() => {
    setSubRequests([
      {
        source: 'local',
        filter: {
          authors: [pubkey]
        }
      }
    ])
  }, [pubkey])

  return (
    <NoteList
      ref={noteListRef}
      subRequests={subRequests}
      showKinds={showKinds}
      filterMutedNotes={false}
      sinceTimestamp={groupedNotesSince}
      filterFn={(event: Event): boolean => {
        if (!includeReplies && isReplyNoteEvent(event)) return false
        return true
      }}
      customFilteredFooter={
        <div className="flex justify-center items-center mt-4 p-4">
          <SecondaryPageLink
            to={toProfile(pubkey)}
            className="text-primary hover:underline text-base font-medium"
          >
            {t('Show full profile')}
          </SecondaryPageLink>
        </div>
      }
    />
  )
}
